
let _ = require('../_.js');
let $ = jQuery;

//
// Code in auctionui-bids and auctionui-tracks is closely related and not well organized.
//
// That a refactor of this code is required is an understatment.
//

let first_load = true;
let first_load_best_item = null;

let old_gallery_photo_list = [];


_.AuctionUI_Tracks = class AuctionUI_Tracks {

    static that;
    static auction_id;
    static is_doing_track_selection_animation = false;
    static had_loaded = false;

    static show_preloader() {
        $("#landproz-auctioncast-auction").children().hide();
        $("#landproz-auctioncast-auction").find(".ac-component-preloader-box").show();
        $("#landproz-auctioncast-auction").find(".ac-greenbox-title").show();
    }

    static is_preloader_visible() {
        return $("#landproz-auctioncast-auction").find(".ac-component-preloader-box").is(":visible");
    }

    static hide_preloader() {
        _.AuctionUI._hide_main_preloader();

        if (_.AuctionUI_Tracks.is_preloader_visible()) {
            $("#landproz-auctioncast-auction").children().show();
            $(".ac-component-preloader-box").hide();
            $(".ac-component-bid-auction-lots-items").show();
            if (_.AuctionUI.auction_is_enterprise() || _.AuctionUI.auction_is_choice()) {
                $(".ac-component-whole-farm-item-area").show();
            }
            _.ac_responsive_adjustHeights();
        }
    }

    static async init() {

        _.ac_state.auction_item_index = 0;

        _.AuctionUI_Tracks.show_preloader();

        // WHOLE FARM ENTERPRISE
        // If it is enterprise bidding, show the enterprise elements, move the containers to the right spots.
        // This only happens once, on init.
        if (_.AuctionUI.auction_is_enterprise()) {
            $(".ac-component-bid-auction-lots-items").appendTo($(".ac-component-individual-item-container"));
            $(".ac-component-bid-auction-lots-items-overflow").removeClass("ac-component-bid-auction-lots-items-overflow");
        }

        // CHOICE AUCTION GROUPING
        // Reuse the enterprise HTML structure for Available/Sold grouping.
        // Items container goes in the top section (available), sold items move to bottom section.
        if (_.AuctionUI.auction_is_choice()) {
            $(".ac-component-bid-auction-lots-items").appendTo($(".ac-component-whole-farm-item-container"));
            $(".ac-component-bid-auction-lots-items-overflow").removeClass("ac-component-bid-auction-lots-items-overflow");
            // Replace enterprise labels with choice labels
            $(".ac-component-whole-farm-item-status div:first").html(
                "AVAILABLE <span class='ac_noun_item_plural_upper'>TRACTS</span>"
            );
            $(".ac-component-individual-item-status div:first").html(
                "SOLD <span class='ac_noun_item_plural_upper'>TRACTS</span>"
            );
            // Hide enterprise-specific badge/price/notice elements
            $("#ac-component-whole-farm-item-badge, #ac-component-whole-farm-item-price").hide();
            $("#ac-component-individual-item-badge, #ac-component-individual-item-price").hide();
        }

        // Function to refresh items.
        _.redraw_auction_items = _.exclusive(async function () {

            console.log("Redraw auction items");

            let items = await _.ac_state.auction.auction_items.fetch();

            // Set multitrack flag if appropriate.  This is used by a few UI elements to show / not show buttons
            _.landproz_layout_set_options({ 'multitrack': items.length > 1 });

            // Sort by user defined order
            items.sort(function (a, b) {
                return a.order - b.order;
            });

            // Update lots list in bidding area

            let $container = $(".ac-component-bid-auction-lots-items");
            let found_ids = [];

            let updater_promises = [];

            // These aren't referenced in code anywhere...
            // Delete me?
            if (_.AuctionUI.auction_is_standard_or_enterprise() || _.AuctionUI.auction_is_sealed_bid()) {
                $(".ac-bid-standard-hide").hide();
            } else if (_.AuctionUI.auction_is_choice()) {
                $(".ac-bid-choice-hide").hide();
            }
            // else if (_.AuctionUI.auction_is_sealed_bid()) {
            //     console.log("TODO: sealed bid");
            // }

            // Preload some information in parallel
            items.forEach(async function (item, index) {

                if (_.AuctionUI.auction_is_standard_or_enterprise()) {
                    let round = await item.auction_round.fetch();
                    if (round) {
                        if (round.current_bid) {
                            round.current_bid.fetch(); // ajax
                        }
                        _.Lib_Auction_Bids.best_bid_by_user(round); // ajax
                    }
                }
            }
            );

            let enterprise_whole_farm_round = null;
            let enterprise_current_item_is_whole_farm = false;
            let enterprise_current_item_ask = 0;
            let enterprise_current_item_increment = 0;

            // $(".ac-greenbox-title-extra").hide();

            // Process items in parallel
            items.forEach(function (item, index) {

                updater_promises.push((async () => {

                    found_ids.push(item.id);

                    // Completed items in choice auction should always be at the bottom of the list, in the order they were won.
                    let order = item.order;

                    if (_.AuctionUI.auction_is_choice()) {
                        if (item.status_is_complete) {
                            order = order + 100000;
                            // Reverse chronological order by round number.
                            if (item.auction_round_id) {
                                let round = await item.auction_round.fetch();
                                order += (1000 - round.round_number);
                            }
                        }
                    }

                    // Create / get component
                    let $component = null;

                    // Handle whole farm item
                    if (_.AuctionUI.auction_is_enterprise()) {
                        let round = await item.auction_round.fetch();

                        if (round.enterprise_is_whole_farm) {
                            // See if we already made the component.  It won't be in the $container if we have.
                            $component = $("#auction-item-" + item.id);
                            if (!$component.length) {
                                // Create it and put it in its destination placeholder.
                                $component = $container.component(item.id);
                                $component.appendTo($(".ac-component-whole-farm-item-container"));
                                $component.attr('id', "auction-item-" + item.id);
                            }

                            // Save this for later use.
                            enterprise_whole_farm_round = round;
                        }
                    }

                    // Handle choice sold/no-sale items -- move to sold container
                    if (!$component && _.AuctionUI.auction_is_choice() && item.status_is_complete) {
                        let $sold_container = $(".ac-component-individual-item-container");
                        $component = $("#auction-item-" + item.id);
                        if ($component.length) {
                            // Exists -- ensure it's in the sold container
                            if (!$component.parent().is($sold_container)) {
                                $component.appendTo($sold_container);
                            }
                        } else {
                            $component = $container.component(item.id);
                            $component.appendTo($sold_container);
                            $component.attr('id', "auction-item-" + item.id);
                        }
                        $component.data('choice-sold-order', order);
                    }

                    // Standard element creation
                    if (!$component) {
                        // If choice item was previously in the sold container (no sale/reopen), remove it
                        if (_.AuctionUI.auction_is_choice()) {
                            let $existing = $("#auction-item-" + item.id);
                            if ($existing.length && !$existing.parent().is($container)) {
                                $existing.remove();
                            }
                        }
                        $component = $container.component(item.id, 'default', { sort_id: order, 'direction': 'asc' });
                        $component.attr('id', "auction-item-" + item.id);
                    }

                    $component.addClass("ac-item-id-" + item.id)
                    $component.data("ac-item-index", index)

                    // These aren't referenced in code anywhere...
                    // Delete me?
                    if (_.AuctionUI.auction_is_standard_or_enterprise()) {
                        $component.find(".ac-bid-standard-hide").hide();
                    } else if (_.AuctionUI.auction_is_choice()) {
                        $component.find(".ac-bid-choice-hide").hide();
                    } else if (_.AuctionUI.auction_is_sealed_bid()) {
                        // $component.find(".ac-bid-standard-hide").hide();
                        // $component.find(".ac-bid-choice-hide").hide();
                    }
                    // End delete me

                    if (index == _.ac_state.track) {
                        $component.addClass("active");
                    }

                    // Set content
                    // Title
                    let $titleContainer = $component.find(".ac-component-bid-auction-lots-item-title-container");
                    let $title = $component.find(".ac-component-bid-auction-lots-item-title");
                    $title.text(item.title + (item.acres ? " - " + item.acres + " " + _.property_noun_unit_plural_ucwords_plusminus() : ""));

                    let $descriptionContainer = $component.find(".ac-component-bid-auction-lots-item-short-desc");
                    $descriptionContainer.text(item.brief_description);

                    // Image
                    let _item = item;
                    $component.find(".ac-component-bid-auction-lots-item-photo-thumbnail").css('opacity', '0');
                    (async () => {
                        let featuredPhoto = await _item.featuredPhoto.fetch();
                        if (featuredPhoto) {
                            $component.find(".ac-component-bid-auction-lots-item-photo-thumbnail").css('opacity', '1');
                            $component.find(".ac-component-bid-auction-lots-item-photo-thumbnail").divimg(featuredPhoto);
                        }
                    })();


                    // -------------------------------------------------
                    // The following code gets the best badge possible, and places an instance of it into '$status_container'.
                    // This element will then be added into dom.

                    // REFACTOR AND CLEAN UP

                    let BADGE_CLASS = "ac-component-bid-auction-lots-item-badge"

                    let $status_container = $("<span class='" + BADGE_CLASS + "'></span>");

                    let round = null;
                    let current_price = null;
                    let hide_price_summary = false;
                    let price_status_string = '';
                    let has_total_details = false;

                    // Load data in parallel
                    if (_.AuctionUI.auction_is_sealed_bid()) {
                        round = await item.auction_round.fetch();

                        if (round.status == App_Models_AuctionRound.STATUS_ACTIVE) {
                            hide_price_summary = true;
                        }
                    }

                    if (!_.AuctionUI.auction_is_choice()) {
                        // Standard, Enterprise
                        round = await item.auction_round.fetch();

                        if (!round) {
                            _.shouldnt_happen();
                            $container.hide();
                            return;
                        }

                        // Bid things go here.
                        let current_bid = round.current_bid ? (await round.current_bid.fetch()) : null;
                        current_price = round.current_price;
                        let best_bid_by_user = await _.Lib_Auction_Bids.best_bid_by_user(round);

                        let registrant = _.ac_state.registrant;
                        let is_high_bidder = registrant && current_bid && current_bid.registrant.id == registrant.id && current_bid.status == App_Models_Bid.STATUS_ACCEPTED;
                        let is_outbid = current_bid && best_bid_by_user && best_bid_by_user.id != current_bid.id && !is_high_bidder;  // !is_outbid is a bandaid here, during refactor, reconsider this logic to make sure correct

                        // Status Badge
                        // if (!_.AuctionUI.auction_is_enterprise()) {
                        let $status_badge = $('<span class="badge bg-small"></span>');

                        let desired_badge_text = round.status_label;
                        let desired_badge_class = round.status_badge_frontend;

                        $status_badge.addClass(desired_badge_class);
                        $status_badge.text(desired_badge_text);
                        $status_badge.addClass("badge-item-" + round.status_constant);
                        $status_container.append($status_badge);
                        // }

                        $status_container.set_conditional_class("ac-component-bid-auction-lots-bg-sold", round.status == App_Models_AuctionRound.STATUS_SOLD);

                        // Relisted badge for converted no-sale tracts
                        if (item.converted_to_auction_id) {
                            let $relisted_badge = $('<span class="badge bg-small badge-info badge-item-relisted">RELISTED</span>');
                            $status_container.append($relisted_badge);
                        }

                        // High bidder / outbid notices: only show if auction is not in a "no sale" state:
                        if (!round.status_is_unsold) {

                            // High Bid
                            if (is_high_bidder) {
                                let $high_bidder_badge = $('<span class="badge bg-small"></span>');
                                $high_bidder_badge.addClass("badge-success");
                                if (round.status == App_Models_AuctionRound.STATUS_SOLD) {
                                    $high_bidder_badge.text("WINNER");
                                    $high_bidder_badge.addClass("badge-item-winner");
                                } else {
                                    $high_bidder_badge.text("HIGH BIDDER");
                                    $high_bidder_badge.addClass("badge-item-high-bidder");
                                }
                                $status_container.append($high_bidder_badge);
                            }

                            // Outbid
                            if (is_outbid) {
                                let $outbid_badge = $("<span class='badge bg-small'></span>");
                                $outbid_badge.addClass(App_Models_Bid.status_enum_val()[App_Models_Bid.STATUS_OUTBID].badge_frontend);
                                $outbid_badge.text(App_Models_Bid.status_enum_val()[App_Models_Bid.STATUS_OUTBID].label);
                                $outbid_badge.addClass("badge-item-outbid");
                                $status_container.append($outbid_badge);
                            }

                        }

                        // Price Status
                        if (current_bid) {
                            has_total_details = true;
                            if (current_bid.paddle_number) {
                                price_status_string += "High Bidder: <strong>[" + current_bid.paddle_number + "]</strong><br />"
                            } else {
                                let current_bid_registrant = await current_bid.registrant.fetch();
                                if (current_bid_registrant && current_bid_registrant.is_floor) {
                                    price_status_string += "High Bidder: <strong>[Floor]</strong><br />";
                                } else {
                                    _.shouldnt_happen();
                                }
                            }
                        }

                        if (!current_bid) {
                            price_status_string += "Starting Bid: ";
                        }

                    } else if (_.AuctionUI.auction_is_choice()) {

                        let $status_badge = $('<span class="badge bg-small"></span>');

                        let auctions_active_round = _.ac_state.auction.current_round.fetch();
                        if (!auctions_active_round) {
                            auctions_active_round = await _.AuctionUI.get_current_round();
                        }

                        if (item.status == App_Models_AuctionItem.STATUS_AVAILABLE) {
                            if (auctions_active_round.status_can_bid) {
                                $status_badge
                                    .text("ACTIVE BIDDING")
                                    .addClass("badge-success")
                                    .addClass("badge-item-title-accepting")
                                    .css("font-size", "13px");
                            } else {
                                $status_badge
                                    .text("Available")
                                    .addClass("badge-success")
                                    .addClass("badge-item-title-accepting")
                                    .css("font-size", "13px");
                            }
                        } else if (item.status == App_Models_AuctionItem.STATUS_NO_SALE) {
                            $status_badge
                                .text(item.status_label)
                                .addClass("badge-danger")
                                .css("font-size", "13px");
                        } else {
                            let sold_round = await item.auction_round.fetch();

                            if (sold_round) {
                                let sold_text = "Sold on Round " + sold_round.round_number;
                                let you_did_win = false;

                                let sold_round_high_bid = sold_round.current_bid ? (await sold_round.current_bid.fetch()) : null;

                                if (sold_round_high_bid && sold_round_high_bid.paddle_number) {
                                    if (_.ac_state.registrant && _.ac_state.registrant.id == sold_round_high_bid.registrant_id) {
                                        you_did_win = true;
                                        sold_text += " - WINNER";
                                    } else {
                                        sold_text += " to [" + sold_round_high_bid.paddle_number + "]";
                                    }
                                }

                                // High Bid
                                if (you_did_win) {
                                    $status_badge
                                        .text(sold_text)
                                        .addClass("badge-success")
                                        .addClass("badge-item-winner")
                                        .css("font-size", "13px")
                                        ;
                                } else {
                                    $status_badge
                                        .text(sold_text)
                                        .addClass("badge-secondary")
                                        .addClass("badge-item-high-bidder")
                                        .css("font-size", "13px")
                                        ;
                                }
                            } else {
                                _.shouldnt_happen();

                                $status_badge
                                    .text("Sold")
                                    .addClass("badge-secondary")
                                    .css("font-size", "13px")
                                    ;
                            }
                        }

                        $status_container.empty().append($status_badge);

                        // choice - identify most relevant round
                        if (item.auction_round_id && item.status == App_Models_AuctionItem.STATUS_SOLD) {
                            round = await item.auction_round.fetch();
                        } else {
                            round = await _.AuctionUI.get_current_round();
                        }

                        // Update price status string
                        let current_bid = round.current_bid ? (await round.current_bid.fetch()) : null;
                        current_price = round.current_price;

                        if (round.status == App_Models_AuctionRound.STATUS_SOLD &&
                            item.status == App_Models_AuctionItem.STATUS_SOLD &&
                            item.auction_round_id) {
                            // price_status_string += 'Winning Bid: ';
                            if (current_bid) {
                                has_total_details = true;
                                if (current_bid.paddle_number) {
                                    price_status_string += 'Sold on Round ' + round.round_number + ' to <strong>[' + current_bid.paddle_number + ']</strong> for:<br />';
                                } else {
                                    price_status_string += 'Sold on Round ' + round.round_number + ' to <strong>[Floor]</strong> for:<br />';
                                }
                            }
                        } else {
                            price_status_string += 'Estimated price for Round ' + round.round_number + ':<br />';
                        }

                        // Hide price summary for no-sale items
                        if (item.status == App_Models_AuctionItem.STATUS_NO_SALE) {
                            hide_price_summary = true;
                            price_status_string = '';
                        }

                        // Blank out string if round is in finalizing or sold state but the item is not sold
                        if ((round.status == App_Models_AuctionRound.STATUS_SOLD || round.status == App_Models_AuctionRound.STATUS_FINALIZING) &&
                            (item.status != App_Models_AuctionItem.STATUS_SOLD || !item.auction_round_id)) {
                            hide_price_summary = true;
                        }
                    }

                    if (!hide_price_summary) {
                        price_status_string += await _.AuctionUI.fees_string_v2_single_line_item(item, round);
                    }

                    let $item_bid_status = $component.find(".ac-component-bid-auction-lots-item-bid-status");

                    if (has_total_details) {
                        // This is the price data.
                        $item_bid_status.show().html(price_status_string);

                        // Pop '<strong>' elements on change
                        let old_val = $item_bid_status.data('old-value');
                        if (old_val && old_val != price_status_string) {
                            $item_bid_status.find('strong').each(function () {
                                $(this).popValue();
                            });
                        }
                        if (price_status_string != '') {
                            $item_bid_status.data('old-value', price_status_string);
                        }

                    } else if (item.pricing_style == App_Models_AuctionItem.PRICING_STYLE_FLAT) {
                        if (item.acres) {
                            $item_bid_status.show().html(item.acres + " " + _.property_noun_unit_plural_ucwords_plusminus() + ", Flat Price Bidding");
                        } else {
                            $item_bid_status.show().html("Flat Price Bidding");
                        }
                    } else {
                        if (item.acres) {
                            $item_bid_status.show().html(item.acres + " " + _.property_noun_unit_plural_ucwords_plusminus() + ", " +
                                "Per " + _.property_noun_unit_singular_ucwords() + " Bidding");
                        } else {
                            _.shouldnt_happen();
                            $item_bid_status.show().html("");
                        }
                    }

                    // Show sealed bid user submitted bid, if any, if it is a sealed bid auction
                    if (_.AuctionUI.auction_is_sealed_bid() && _.ac_state.registrant) {

                        let best_bid_by_user = await _.Lib_Auction_Bids.best_bid_by_user(round);

                        if (best_bid_by_user) {
                            let price_explanation = '';

                            if (item.pricing_style == App_Models_AuctionItem.PRICING_STYLE_PER_ACRE) {
                                price_explanation = await _.AuctionUI.fees_string_v2_single_line_acres(best_bid_by_user.amount, item.acres);
                            } else {
                                price_explanation = await _.AuctionUI.fees_string_v2_single_line_flat(best_bid_by_user.amount, item.acres);
                            }

                            $item_bid_status.append("<div style='margin-top:3px;'><strong>Your Bid:</strong> " + price_explanation + "</div>");
                        } else {
                            $item_bid_status.append("<div style='margin-top:3px; font-style:italic;'>No Bid Placed</div>");

                        }

                    }

                    // ---- price summary complete ----

                    $titleContainer.find('.ac-component-bid-auction-lots-item-badge-container').empty().append($status_container);

                    $component.removeClass('lots-item-color-available');
                    $component.removeClass('lots-item-color-unavailable');
                    $component.removeClass('lots-item-color-selected');
                    $component.removeClass('lots-item-color-highlighted');
                    $component.removeClass('lots-item-color-enterprise-top-bid');
                    $component.removeClass('lots-item-color-enterprise-low-bid');
                    $component.removeClass('lots-item-color-enterprise-highlighted');
                    $component.removeClass('lots-item-color-enterprise-highlighted');
                    $component.removeClass('lots-item-status-nosale');

                    if (_.AuctionUI.auction_is_standard() || _.AuctionUI.auction_is_sealed_bid()) {
                        if (!round || !round.status_can_bid || item.status != App_Models_AuctionItem.STATUS_AVAILABLE) {
                            $component.addClass('lots-item-color-unavailable');
                        } if (_.ac_state.auction.highlighted_item_id == item.id) {
                            $component.addClass('lots-item-color-highlighted');
                        } else {
                            $component.addClass('lots-item-color-available');
                        }
                    } else if (_.AuctionUI.auction_is_enterprise()) {
                        let auction = await round.auction.fetch();
                        if (!round || !round.status_can_bid) {
                            $component.addClass('lots-item-color-unavailable');
                        } else if (!auction.enterprise_has_any_bids) {
                            $component.addClass('lots-item-color-available');
                        } else if (round.enterprise_is_top_bid) {
                            $component.addClass('lots-item-color-enterprise-top-bid');
                        } else {
                            $component.addClass('lots-item-color-enterprise-low-bid');
                        }
                        if (_.ac_state.auction.highlighted_item_id == item.id) {
                            $component.addClass('lots-item-color-enterprise-highlighted');
                        }
                    } else {
                        if (_.ac_state.auction.highlighted_item_id == item.id) {
                            $component.addClass('lots-item-color-highlighted');
                        } else if (item.status_is_complete) {
                            $component.addClass('lots-item-color-unavailable');
                        } else {
                            $component.addClass('lots-item-color-available');
                        }
                    }

                    // ---------------------------------------

                    // ----- Show selected item details ------

                    if (item.id == _.ac_state.current_item_id) {

                        $component.addClass('lots-item-color-selected');

                        // Render facts about item

                        $(".ac-page-lot-facts-title").text(item.title);

                        if (!_.AuctionUI.auction_is_choice()) {
                            $(".ac-greenbox-title-extra").text(" - " + item.title).show();
                        }

                        if (item.acres) {
                            $(".ac-page-lot-facts-acres").show().text(
                                _.property_noun_unit_plural_ucwords() + ": " + _.represent_units_with_plusminus(item.acres));
                        } else {
                            $(".ac-page-lot-facts-acres").hide();
                        }

                        let badge = item.status_badge_frontend;
                        let label = item.status_label;
                        let round = await item.auction_round.fetch();

                        if (round && !_.AuctionUI.auction_is_choice()) {
                            badge = round.status_badge_frontend;
                            label = round.status_label;
                        }

                        $(".ac-page-lot-facts-status").attr('class', 'ac-page-lot-facts-status')
                            .addClass(badge)
                            .text(label);

                        if (round && round.enterprise_is_whole_farm) {
                            enterprise_current_item_is_whole_farm = true;
                        } else {
                            enterprise_current_item_is_whole_farm = false;
                        }

                        if (round) {
                            enterprise_current_item_increment = round.increment;
                        }

                        if (round) {
                            $(".ac-page-lot-has-bid").show();
                            let bid = await round.current_bid.fetch();
                            if (bid) {
                                $(".ac-page-lot-facts-high-bid").text(_.currency(bid.amount));
                            } else {
                                $(".ac-page-lot-facts-high-bid").text("");
                            }
                            $(".ac-page-lot-facts-ask").text(_.currency(round.ask));
                            $(".ac-page-lot-facts-num-bids").text(await _.Lib_Auction_Bids.count_total_bids(round));
                        } else {
                            $(".ac-page-lot-has-bid").hide();
                        }

                        $(".ac-page-lot-description").html(item.brief_description);

                        // Photo 
                        let featuredPhoto = await item.featuredPhoto.fetch();

                        if (featuredPhoto) {
                            // console.log(featuredPhoto);
                            $(".ac-page-lot-facts-featured-photo-thumbnail").divimg(featuredPhoto);
                            $(".ac-page-lot-facts-featured-photo-thumbnail-link").attr('href', featuredPhoto.direct_url);
                        } else {
                            $("#ac-page-lot-facts-photo-thumbnail").divimg();
                            $("#ac-page-lot-facts-photo-thumbnail-link").attr('href', "#");
                        }

                        // Gallery
                        let $gallery = $(".ac-page-lot-gallery");
                        if (items.length <= 1) {
                            $gallery.hide();
                        } else {
                            $gallery.show();

                            let all_photos = [];
                            let all_photos_ids = [];

                            // if (featuredPhoto) {
                            //     all_photos.push(featuredPhoto);
                            //     all_photos_ids.push(featuredPhoto.id);
                            // }

                            let item_photos = await item.photos.fetch();

                            for (let photo of item_photos) {
                                all_photos.push(photo);
                                all_photos_ids.push(photo.id);
                            }

                            let found_photo_hash = [];
                            for (let photo of item_photos) {
                                found_photo_hash.push(photo.id + "_" + photo.order);
                            }

                            let found_photo_hash_json = JSON.stringify(found_photo_hash);

                            if (old_gallery_photo_list != found_photo_hash_json) {
                                // Redraw required.
                                old_gallery_photo_list = found_photo_hash_json;

                                $gallery.empty();

                                if ($gallery.hasClass('slick-slider')) {
                                    $gallery.slick('unslick');
                                }

                                $gallery.empty();

                                for (let photo of all_photos) {
                                    let $photo_container = $gallery.component(photo.id, 'default', { sort_id: photo.order, 'direction': 'asc', speed: 0 });
                                    $photo_container.hide();
                                    $photo_container.find('.ac-page-lot-facts-photo-thumbnail').divimg(photo);
                                    $photo_container.attr('href', photo.direct_url);
                                }

                                $gallery.remove_unlisted_components(all_photos_ids);

                                _.on_update_slick_track_item_gallery();

                                // if (item_photos.length > 0) {
                                // }
                            }
                        }
                    }

                })());
            });

            await Promise.all(updater_promises);

            // Handle enterprise badges.
            if (_.AuctionUI.auction_is_enterprise() && enterprise_whole_farm_round) {

                let no_bid_text = "No Top Bid";
                let no_bid_class = "badge-secondary";
                let top_bid_text = "Top Bid";
                let top_bid_class = "bid-badge-ent-topbid";
                let low_bid_text = "Low Bid";
                let low_bid_class = "bid-badge-ent-lowbid";

                let $wfib = $("#ac-component-whole-farm-item-badge");
                let $iib = $("#ac-component-individual-item-badge");
                let $wfip = $("#ac-component-whole-farm-item-price");
                let $iip = $("#ac-component-individual-item-price");

                $wfib.attr('class', 'badge badge-medium-inherit');
                $iib.attr('class', 'badge badge-medium-inherit');

                if (!_.ac_state.auction.enterprise_has_any_bids) {
                    $wfib.addClass(no_bid_class).text(no_bid_text);
                    $iib.addClass(no_bid_class).text(no_bid_text);
                } else if (_.ac_state.auction.enterprise_whole_farm_is_top_bid == true) {
                    $wfib.addClass(top_bid_class).text(top_bid_text);
                    $iib.addClass(low_bid_class).text(low_bid_text);
                } else {
                    $wfib.addClass(low_bid_class).text(low_bid_text);
                    $iib.addClass(top_bid_class).text(top_bid_text);
                }

                let wf_current_bid = await enterprise_whole_farm_round.current_bid.fetch();

                if (_.ac_state.auction.enterprise_whole_farm_current_price) {
                    $wfip.text(_.currency(_.ac_state.auction.enterprise_whole_farm_current_price));
                } else {
                    $wfip.text("(No Bids)");
                }

                // Pop amount text if number changes
                let old_val = $wfip.data('old-value');
                if (old_val && $wfip.text() != '' && old_val != $wfip.text()) {
                    $wfip.popValue();
                }
                if ($wfip.text() != '') {
                    $wfip.data('old-value', $wfip.text());
                }

                if (_.ac_state.auction.enterprise_individual_tracts_total_current_price) {
                    $iip.text(_.currency(_.ac_state.auction.enterprise_individual_tracts_total_current_price));
                } else {
                    $iip.text("(No Bids)");
                }

                // Pop amount text if number changes
                old_val = $iip.data('old-value');
                if (old_val && $iip.text() != '' && old_val != $iip.text()) {
                    $iip.popValue();
                }
                if ($iip.text() != '') {
                    $iip.data('old-value', $iip.text());
                }

            }

            // Choice auction: always show grouping area (available items live inside it),
            // show/hide sold section based on whether items have been sold, sort sold items
            if (_.AuctionUI.auction_is_choice()) {
                $(".ac-component-whole-farm-item-area").show();
                let $sold_container = $(".ac-component-individual-item-container");
                let has_sold = $sold_container.children().length > 0;
                if (has_sold) {
                    $(".ac-component-individual-item-status").show();
                    $sold_container.show();
                    // Sort sold items by their order value
                    let $sold_items = $sold_container.children();
                    if ($sold_items.length > 1) {
                        $sold_items.sort(function (a, b) {
                            return ($(a).data('choice-sold-order') || 0) - ($(b).data('choice-sold-order') || 0);
                        });
                        $sold_container.append($sold_items);
                    }
                } else {
                    $(".ac-component-individual-item-status").hide();
                    $sold_container.hide();
                }

                // Clean up sold container for removed items
                let found_ids_str = found_ids.map(String);
                $sold_container.children().each(function () {
                    let cid = $(this).attr('data-cid');
                    if (cid && !found_ids_str.includes(cid)) {
                        $(this).remove();
                    }
                });
            }

            // Remove no longer active data
            $container.remove_unlisted_components(found_ids);

            // Hack - Let the tracks load before showing bidding area.
            // This marks this module loaded, the bidding module will render next.
            if (!_.AuctionUI_Tracks.has_loaded) {
                _.AuctionUI_Tracks.has_loaded = true;
                if (_.AuctionUI_Bids) {
                    await _.AuctionUI_Bids._update_bidding_ui(); // gross, I know...
                }
            }

            // Finally, hide preloader if it is visible
            _.AuctionUI_Tracks.hide_preloader();

            // Is this the first load?  If so, register a resize handler.
            if (first_load) {
                first_load = false;

                // Reload slick track item gallery on resize
                _.on_ui_resize(function () {
                    // Calling an async function to cheat the self imposed model of atomic updates with
                    // _.on_ui_resize
                    _.on_update_slick_track_item_gallery();
                });
            }


        });

        // Generic window redraw function
        _.on_tracks_resize_generic = function () {
            // Add a 'return to items' button on description if mobile
            if (_.isMobileViewport()) {
                $(".btn-return-tract-container").show();
            } else {
                $(".btn-return-tract-container").hide();
            }
        }
        _.on_ui_resize(_.on_tracks_resize_generic);
        _.on_tracks_resize_generic();

        $(".btn-return-tract").click(function () {
            _.scrollPageIntoViewIfNeeded(".ac-component-bid-auction-lots-items");
        });

        // Reload slick for item gallery if appropriate
        _.on_update_slick_track_item_gallery = _.debounce(100, async function () {
            // console.log("on_update_slick_track_item_gallery");

            let $gallery = $(".ac-page-lot-gallery");

            let child_width = null;

            // Cache the width of a child element
            if ($gallery.data('child-width')) {
                child_width = $gallery.data('child-width');
            }

            if (!$gallery.data('child-width')) {
                if ($gallery.children().length <= 0) {
                    return;
                }
                child_width = $gallery.children().first().width() + 10;
                $gallery.data('child-width', child_width);
            }

            let gallery_width = $gallery.width();
            let extra_for_arrows = 50;

            // At least one slide: a hidden / narrow gallery would give slick 0 or negative slidesToShow
            let show_num_elements = Math.max(1, Math.floor((gallery_width - extra_for_arrows) / child_width));

            if (!$gallery.data('show_num_elements') || $gallery.data('show_num_elements') != show_num_elements || !$gallery.hasClass('slick-slider')) {
                if ($gallery.hasClass('slick-slider')) {
                    $gallery.slick('unslick');
                }
                $gallery.find('a').off('click.magnificPopup');
                $gallery.find('a').removeData('magnificPopup');
                if ($gallery.children().length <= 0) {
                    return;
                }
                $gallery.data('show_num_elements', show_num_elements);

                // Hack to make sure we dont jump to a weird height while slick loads.
                let $outside_container = $("#landproz-auctioncast-auction");

                if (!$gallery.find('a:visible').length) {
                    var originalHeight = $outside_container.height();
                    $outside_container.css({
                        'max-height': (originalHeight + 66) + 'px',
                        'overflow': 'hidden'
                    });
                    $gallery.on('init', function () {
                        setTimeout(function () {
                            $outside_container.css({
                                'max-height': '',
                                'overflow': ''
                            });
                        }, 1000);
                    });
                }

                // Show the photo elements if they were hidden from initial load of this item
                $gallery.find('a').show();

                $gallery.css('overflow', 'hidden');
                $gallery.css('opacity', '0');

                // Initialize Slick and then remove the max-height and overflow hidden
                $gallery.slick({
                    infinite: true,
                    autoplay: false,
                    adaptiveHeight: true,
                    arrows: true,
                    slidesToShow: show_num_elements,
                    slidesToScroll: show_num_elements,
                });

                await _.sleep(200);

                $gallery.css('overflow', '');
                $gallery.css('opacity', '1');

                $gallery.find('a').magnificPopup({
                    type: 'image',
                    gallery: {
                        enabled: true
                    },
                    image: {
                        // titleSrc: 'title' // Grabs the caption from the title attribute of the `a` tag
                    }
                });
            }
        });

        // Display list of lots under bidding box, or lot details modal
        _.AuctionUI.on_update_auction_items(_.redraw_auction_items);

        // // Handle clicking on an item track
        _.on_ui_update_once('.ac-component-bid-auction-lots-item', function () {
            $(this).click(async function () {

                _.AuctionUI_Tracks.show_preloader();
                $(".ac-page-lot-gallery").find('a').remove();

                // Signal other parts of the program that this is happening.
                let item_id = $(this).data("cid") * 1;

                _.AuctionUI.set_current_item(item_id);

                if (_.isMobileViewport()) {
                    // Scroll to item.
                    _.scrollPageIntoViewIfNeeded(".ac-component-bid");
                }

            })
        });

        _.on_ui_update_once('.btn-full-item-description', function () {
            $(this).click(async function () {
                let item = await _.AuctionUI.get_current_item();
                if (item) {
                    _.show_item_details_modal(item);
                }
            });
        });


    }

}